import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, TrendingUp, Trophy, Users, Shield, CreditCard, BarChart, FileText, AlertCircle } from 'lucide-react';

const news = [
  {
    id: 'tendances-paris-sportifs-2025',
    title: 'Les Tendances des Paris Sportifs en 2025',
    excerpt: 'Découvrez les sports et marchés qui génèrent le plus de gains cette année, et comment adapter votre stratégie pour maximiser vos chances de succès.',
    date: '22.11.2025',
    category: 'Stratégie',
    icon: TrendingUp,
    color: 'from-blue-600 to-blue-800',
    image: '/images/stephen-baker-QAX5Ylx-lKo-unsplash.webp',
  },
  {
    id: 'nouveaux-bonus-novembre',
    title: 'Nouveaux Bonus Disponibles ce Mois',
    excerpt: 'Une sélection exclusive des meilleures promotions du moment : bonus doublés, freebets, et offres spéciales pour les événements sportifs majeurs à venir.',
    date: '20.11.2025',
    category: 'Promotions',
    icon: Trophy,
    color: 'from-pink-600 to-pink-800',
    image: '/images/julia-kuzenkov-UTLqS1wa104-unsplash.webp',
  },
  {
    id: 'gerer-bankroll-professionnel',
    title: 'Guide : Gérer son Bankroll comme un Pro',
    excerpt: 'Les techniques utilisées par les parieurs expérimentés pour préserver leur capital, éviter les mises émotionnelles et parier de manière rationnelle sur le long terme.',
    date: '18.11.2025',
    category: 'Guides',
    icon: Users,
    color: 'from-green-600 to-green-800',
    image: '/images/philippe-gras-WkvOwzndn94-unsplash.webp',
  },
  {
    id: 'reglementations-anj-2025',
    title: 'Nouvelles Réglementations ANJ en 2025',
    excerpt: 'Les changements réglementaires qui impactent le secteur français des paris en ligne cette année, et comment ils affectent votre expérience de parieur.',
    date: '15.11.2025',
    category: 'Réglementation',
    icon: Shield,
    color: 'from-red-600 to-red-800',
    image: '/images/joshua-kantarges-N_7Kb4hpaoU-unsplash.webp',
  },
  {
    id: 'methodes-paiement-rapides',
    title: 'Les Méthodes de Paiement les Plus Rapides',
    excerpt: 'Comparatif détaillé des options de retrait disponibles sur les sites français : quelles méthodes offrent vraiment les délais les plus courts pour accéder à vos gains.',
    date: '12.11.2025',
    category: 'Guide',
    icon: CreditCard,
    color: 'from-purple-600 to-purple-800',
    image: '/images/tj-dragotta-Gl0jBJJTDWs-unsplash.webp',
  },
  {
    id: 'analyse-cotes-competitives',
    title: 'Comment Identifier les Cotes les Plus Compétitives',
    excerpt: 'Techniques avancées pour comparer les cotes entre sites et repérer les meilleures opportunités. Maximisez vos gains en choisissant toujours la meilleure cote disponible.',
    date: '10.11.2025',
    category: 'Stratégie',
    icon: BarChart,
    color: 'from-yellow-600 to-yellow-800',
    image: '/images/jannik-mY2ZHBU6GRk-unsplash.webp',
  },
  {
    id: 'live-betting-strategies',
    title: 'Stratégies Gagnantes du Live Betting',
    excerpt: 'Maîtrisez l\'art du pari en direct avec ces techniques éprouvées. Apprenez à lire le match, identifier les moments clés, et profiter des mouvements de cotes en temps réel.',
    date: '08.11.2025',
    category: 'Stratégie',
    icon: FileText,
    color: 'from-indigo-600 to-indigo-800',
    image: '/images/tricia-sarrazin-MpLWgzKcn0s-unsplash.webp',
  },
  {
    id: 'protection-donnees-parieurs',
    title: 'Protection des Données des Parieurs',
    excerpt: 'Tout ce que vous devez savoir sur la sécurité de vos informations personnelles sur les sites de paris français. Vos droits et les garanties offertes par la régulation ANJ.',
    date: '05.11.2025',
    category: 'Sécurité',
    icon: Shield,
    color: 'from-teal-600 to-teal-800',
    image: '/images/wesley-tingey-dKCKiC0BQtU-unsplash.webp',
  },
  {
    id: 'erreurs-parieurs-debutants',
    title: 'Les 7 Erreurs à Éviter pour les Parieurs Débutants',
    excerpt: 'Les pièges les plus courants qui coûtent cher aux nouveaux parieurs, et comment les éviter dès le départ pour construire une approche solide et durable.',
    date: '03.11.2025',
    category: 'Conseils',
    icon: AlertCircle,
    color: 'from-orange-600 to-orange-800',
    image: '/images/john-fornander-y6_SJpU3Alk-unsplash.webp',
  },
];

const News = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Actualités & Analyses du Monde des Paris en Ligne",
    "description": "Restez informé des dernières tendances, réglementations et stratégies pour optimiser vos paris sportifs en France",
    "url": "https://galo-bet.com/news",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": news.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.title,
        "url": `https://galo-bet.com${item.id ? `/news/${item.id}` : ''}`
      }))
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <SEO 
        title="Actualités & Analyses"
        description="Restez informé des dernières tendances, réglementations et stratégies pour optimiser vos paris sportifs en France. Actualités et analyses du monde des paris en ligne."
        jsonLd={jsonLd}
      />
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            {/* Hero Section */}
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                <span className="bg-gradient-to-r from-pink-400 to-pink-600 bg-clip-text text-transparent">
                  Actualités & Analyses
                </span>
                <br />
                <span className="text-white">Du Monde des Paris en Ligne</span>
              </h1>
              <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                Restez informé des dernières tendances, réglementations et stratégies pour optimiser vos paris sportifs en France
              </p>
            </div>

            {/* News Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
              {news.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.id}
                    to={`/news/${item.id}`}
                    data-discover="true"
                    itemScope
                    itemType="https://schema.org/NewsArticle"
                    className="group bg-gray-800 rounded-xl overflow-hidden border border-gray-700 hover:border-pink-600 transition-all transform hover:-translate-y-2 flex flex-col"
                  >
                    {/* Image */}
                    <div className="h-48 relative overflow-hidden">
                      <img 
                        src={item.image} 
                        alt={item.title} 
                        className="w-full h-full object-cover"
                      />
                      <div className={`absolute inset-0 bg-gradient-to-br ${item.color} opacity-70`}></div>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <Icon className="text-white opacity-40" size={64} />
                      </div>
                      <div className="absolute top-3 left-3">
                        <span className="bg-black/60 backdrop-blur-sm px-3 py-1 rounded-full text-white text-xs font-semibold">
                          {item.category}
                        </span>
                      </div>
                    </div>

                    <div className="p-6 flex-1 flex flex-col">
                      <div className="flex items-center text-gray-400 text-sm mb-3">
                        <Calendar size={14} className="mr-2" />
                        <span>{item.date}</span>
                      </div>

                      <h3 className="text-xl font-bold text-white mb-3 line-clamp-2 group-hover:text-pink-400 transition-colors" itemProp="headline">
                        {item.title}
                      </h3>

                      <p className="text-gray-400 text-sm mb-4 flex-1 leading-relaxed line-clamp-3" itemProp="description">
                        {item.excerpt}
                      </p>

                      <div className="inline-flex items-center space-x-2 text-pink-400 hover:text-pink-300 font-semibold text-sm group/link">
                        <span>Lire la suite</span>
                        <ArrowRight size={16} className="group-hover/link:translate-x-1 transition-transform" />
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>

            {/* How We Choose News Section */}
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 md:p-12 border border-pink-500/20">
              <h2 className="text-3xl font-bold text-white mb-6">
                Comment Nous Sélectionnons Nos Actualités
              </h2>
              <div className="space-y-4 text-gray-300 leading-relaxed text-lg">
                <p>
                  Chaque actualité que nous publions est soigneusement choisie selon des critères stricts qui garantissent sa pertinence, sa fiabilité, et sa valeur réelle pour les parieurs français. Nous ne publions pas pour remplir un calendrier éditorial, mais pour vous fournir des informations qui peuvent concrètement améliorer votre expérience et vos résultats.
                </p>
                <p>
                  Notre premier critère est l'impact réel sur votre activité de parieur. Une nouvelle réglementation de l'ANJ qui change les conditions de retrait, une évolution des cotes sur un type de pari spécifique, ou l'apparition d'une nouvelle stratégie validée par les résultats : nous privilégions les informations actionnables plutôt que les simples actualités générales du secteur.
                </p>
                <p>
                  La vérification et la précision sont absolument non-négociables. Avant de publier une actualité, nous vérifions les sources officielles, croisons les informations, et nous assurons que chaque détail technique est exact. Les parieurs font confiance à nos informations pour prendre des décisions financières importantes, et cette responsabilité guide chaque ligne que nous publions.
                </p>
                <p>
                  Nous suivons de près les évolutions réglementaires françaises car elles impactent directement vos droits et votre protection. Les changements dans les obligations des opérateurs, les nouvelles règles de l'ANJ, ou les évolutions législatives : nous décryptons ces informations complexes pour vous les rendre accessibles et actionnables. Vous devez comprendre comment ces changements vous affectent concrètement.
                </p>
                <p>
                  Les tendances stratégiques occupent également une place importante dans notre sélection. Quand une nouvelle approche de paris émerge et montre des résultats significatifs, quand un sport gagne en popularité avec des opportunités de valeur, ou quand une technique d'analyse prouve son efficacité : nous partageons ces insights pour vous donner un avantage concurrentiel. Ces informations stratégiques sont souvent plus précieuses que les actualités générales.
                </p>
                <p>
                  Nous privilégions également les actualités qui vous aident à éviter les pièges et les erreurs coûteuses. Les alertes sur de nouvelles méthodes de fraude, les mises en garde sur des pratiques douteuses, ou les explications sur des conditions de bonus trompeuses : ces informations protectrices peuvent vous faire économiser beaucoup d'argent et d'ennuis.
                </p>
                <p>
                  La temporalité est cruciale. Nous publions rapidement quand une information devient disponible, mais nous préférons attendre quelques heures pour vérifier plutôt que de diffuser une information non confirmée. Les "exclusivités" précipitées valent moins que des informations vérifiées qui arrivent quelques heures plus tard. Votre confiance et votre sécurité priment sur la vitesse de publication.
                </p>
                <p>
                  Enfin, chaque actualité doit apporter une perspective unique ou une analyse approfondie. Nous ne nous contentons pas de relayer des communiqués de presse. Nous analysons, comparons, et contextualisons les informations pour vous donner une compréhension complète de leur signification réelle. C'est cette valeur ajoutée éditoriale qui transforme une simple nouvelle en un contenu réellement utile.
                </p>
                <p>
                  Notre engagement est clair : chaque actualité que vous lisez ici doit vous permettre de prendre de meilleures décisions, d'éviter des erreurs, ou de découvrir de nouvelles opportunités. Si une information ne répond pas à au moins un de ces critères, nous ne la publions pas. Cette sélectivité garantit que votre temps de lecture est toujours bien investi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default News;

